// How a phone came to be marked verified, when it was not by a code sent to that phone.
// Absent or null: the number itself was proven (SMS code) or staff confirmed it.
export const PHONE_VERIFIED_VIA_EMAIL_FALLBACK = 'email_fallback';

export type PhoneVerifiedVia = typeof PHONE_VERIFIED_VIA_EMAIL_FALLBACK;

export const OTP_DESTINATION_BLOCKED_REASON = 'otp_destination_blocked';
